import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { LoadingAnimation } from '@/common-components/animations/loading/LoadingAnimation';
import {
  clinicalNotesAtom,
  isNarrativeLoadingAtom,
  narrativeAtom,
} from '@/modules/claims/summary/state';

export const ClaimNarrative = () => {
  const narrativeText = useAtomValue(narrativeAtom);
  const clinicalNotes = useAtomValue(clinicalNotesAtom);
  const isLoading = useAtomValue(isNarrativeLoadingAtom);

  return (
    <div>
      <h2 className="vai-font-bold vai-text-lg" data-testid="narrative-title">
        <Trans>Narrative/Notes</Trans>
      </h2>
      {isLoading ? (
        <LoadingAnimation isIconOnly data-testid="narrative-loading" />
      ) : (
        <>
          <div data-testid="narrative-text" className="vai-text-sm">
            {narrativeText || 'None provided.'}
          </div>
        </>
      )}
      {clinicalNotes && (
        <div data-testid="clinical-notes" className="vai-text-sm vai-mt-2">
          {clinicalNotes}
        </div>
      )}
    </div>
  );
};
